export const MYCARSLOT_OPEN_CHAT_EVENT = 'mycarslot:open-chat';

/** Open the site-wide live chat widget (ChatBox). */
export function openMyCarSlotChat() {
  window.dispatchEvent(new CustomEvent(MYCARSLOT_OPEN_CHAT_EVENT));
}
